// https://fordprofile.cms.dealer.com/ford-custom-garage.htm
export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) =>
					className
						.split(' ')
						.includes('custom-garage-search-inventory'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'custom garage:content:search inventory',
							onclickLinkName: 'custom garage:content:action'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('custom-garage-contact-us'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'custom garage:content:contact us',
							onclickLinkName: 'custom garage:content:action'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.split(' ').includes('custom-garage-learn-more'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick: 'referral:learn more',
							onclickLinkName: 'referral:exit',
							referredTo: 'learn more'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) =>
					className
						.split(' ')
						.includes('custom-garage-browse-all-packages'),
				payload: {
					directCall: 'referral-exit',
					payload: {
						onclick: {
							onclick: 'referral:browse all packages',
							onclickLinkName: 'referral:exit',
							referredTo: 'browse all packages'
						},
						event: {
							action: 'brand referral'
						}
					}
				}
			}
		]
	}
};
